import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "modal-container-element" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "filter-block" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 2,
  class: "center"
}
const _hoisted_6 = {
  key: 3,
  class: "center"
}
const _hoisted_7 = {
  key: 4,
  class: "cards-container"
}
const _hoisted_8 = ["card-title", "description", "icon-src", "icon-name", "onClick"]
const _hoisted_9 = {
  slot: "title",
  class: "card-title"
}
const _hoisted_10 = ["actions"]
const _hoisted_11 = ["current-page", "total-pages", "start-item", "end-item", "total-items"]

import { useStore } from 'vuex'
import { ref, computed, watch } from 'vue'
import type { ResourceQueryOptions } from '../models/resource/ui-types';
import { useCatalogServices } from '../queries/useCatalogServicesQueries';
import { useUser } from '../queries/useUserQueries';
import Masthead from '@shell/components/ResourceList/Masthead';
import { EPINIO_TYPES } from '../types'
import CatalogServiceModal from '../components/service/CatalogServiceModal.vue';
import CatalogServiceDeleteModal from '../components/service/CatalogServiceDeleteModal.vue';
import { debounce } from 'lodash';
import { ListResourceRequestParams } from '../models/resource/ui-types';
import { ResourceTableRow } from '../models/resource/ui-types';
import { CatalogService } from '../models/catalogservice/ui-types';
import { createEpinioRoute } from '../utils/custom-routing';
import Banner from '@components/Banner/Banner.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'catalogservices',
  props: {
    schema: {}
  },
  setup(__props: any) {

const store = useStore()
const props = __props; // eslint-disable-line @typescript-eslint/no-unused-vars

const catalogServiceModal = ref<InstanceType<typeof CatalogServiceModal> | null>(null);
const deleteModal = ref<InstanceType<typeof CatalogServiceDeleteModal> | null>(null);

const resource: string = EPINIO_TYPES.CATALOG_SERVICE;

const { data: user, isError: isErrorUser, error: userError } = useUser(store);

const requestParams = ref<ListResourceRequestParams>({
  page: 1,
  pageSize: 9,
  search: '',
});

const requestOptions = ref<ResourceQueryOptions>({
  enabled: true,
  polling: true,
});

const searchQuery = ref<string>('');

watch(searchQuery, (newQuery) => {
  onSearch(newQuery);
});

const onSearch = debounce(async (query: string) => {
  requestParams.value.page = 1;
  requestParams.value.search = query;
}, 500);

const {data: catalogServices, isLoading: isLoadingCatalogServices, isError: isErrorCatalogServices, error: catalogServicesError} = useCatalogServices(store, requestParams, requestOptions);

const canEdit = computed(() => {
  return user.value?.permissions?.catalog_service_write || user.value?.permissions?.catalog_service;
});
const canDelete = canEdit;
const canCreate = canEdit;


const list = computed(() => {
  if (!catalogServices.value) {
    return [];
  }

  // Add custom namespace delete action to replace the built in rancher shell flow.
  // Gate by namespace write perms so view-only / app-only roles don't see Delete.
  const rows: ResourceTableRow<CatalogService>[] = (catalogServices.value.items ?? []).map((s) => ({
    ...s,
    id: s.meta.name, // stable, unique per namespace
    availableActions: [
      {
        label: 'Edit',
        action: () => openEditModal(s),
        enabled: canEdit.value,
        visible: canEdit.value,
      },
      {
        label: 'Delete',
        action: () => openDeleteModal(s),
        enabled: canDelete.value,
        visible: canDelete.value,
        danger: true,
      },
    ],
    canDelete: canDelete.value,
  }));
  return rows;
});

function openDeleteModal(catalogService: CatalogService) {
  deleteModal.value?.openDelete(catalogService);
}

function openEditModal(catalogService: CatalogService) {
  catalogServiceModal.value?.openEdit(catalogService);
}

const showDetails = (catalogService: CatalogService) => {
  const route = createEpinioRoute('c-cluster-resource-id', {
    cluster:   store.getters['clusterId'],
    resource:  resource,
    id: catalogService.meta.name,
  });
  store.$router.push(route);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Masthead), {
        schema: _ctx.schema,
        resource: _unref(resource)
      }, {
        createButton: _withCtx(() => [
          (_unref(canCreate))
            ? (_openBlock(), _createElementBlock("trailhand-button", {
                key: 0,
                variant: "primary",
                size: "large",
                onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (catalogServiceModal.value?.openCreate()))
              }, _toDisplayString(_ctx.t('generic.create')), 33))
            : (_openBlock(), _createElementBlock("div", _hoisted_2))
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(canCreate)) + " ", 1)
        ]),
        _: 1
      }, 8, ["schema", "resource"]),
      _cache[5] || (_cache[5] = _createTextVNode()),
      (_unref(isErrorUser))
        ? (_openBlock(), _createBlock(Banner, {
            key: 0,
            color: "error",
            label: _unref(userError)?.message || _ctx.t('epinio.user.errors.fetch')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _cache[6] || (_cache[6] = _createTextVNode()),
      (_unref(isErrorCatalogServices))
        ? (_openBlock(), _createBlock(Banner, {
            key: 1,
            color: "error",
            label: _unref(catalogServicesError)?.message || _ctx.t('epinio.catalogService.errors.fetchAll')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("trailhand-text-input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
          type: "search",
          class: "input-sm",
          placeholder: _ctx.t('catalog.charts.search')
        }, null, 8, _hoisted_4), [
          [_vModelText, searchQuery.value]
        ])
      ]),
      _cache[8] || (_cache[8] = _createTextVNode()),
      (_unref(isLoadingCatalogServices))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[3] || (_cache[3] = [
            _createElementVNode("trailhand-loading-spinner", null, null, -1)
          ])))
        : _createCommentVNode("", true),
      _cache[9] || (_cache[9] = _createTextVNode()),
      (!_unref(isLoadingCatalogServices) && (!list.value || list.value.length === 0))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(_ctx.t('epinio.catalogService.noServicesFound')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (service) => {
              return (_openBlock(), _createElementBlock("trailhand-card", {
                key: service.id,
                "card-title": service.meta.name,
                description: service.shortDescription,
                "icon-src": service.serviceIcon ? service.serviceIcon : null,
                "icon-name": service.serviceIcon ? null : 'database',
                clickable: "",
                onClick: ($event: any) => (showDetails(service))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h3", null, _toDisplayString(service.meta.name), 1),
                  _cache[4] || (_cache[4] = _createTextVNode()),
                  (service.availableActions && service.availableActions.length > 0)
                    ? (_openBlock(), _createElementBlock("trailhand-action-menu", {
                        key: 0,
                        actions: service.availableActions
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_8))
            }), 128))
          ]))
    ]),
    _cache[10] || (_cache[10] = _createTextVNode()),
    (_unref(catalogServices) && _unref(catalogServices).totalItems > 0)
      ? (_openBlock(), _createElementBlock("trailhand-pagination", {
          key: 0,
          "current-page": _unref(catalogServices).page,
          "total-pages": _unref(catalogServices).totalPages,
          "show-info": false,
          "start-item": (_unref(catalogServices).page - 1) * _unref(catalogServices).pageSize + 1,
          "end-item": Math.min(_unref(catalogServices).page * _unref(catalogServices).pageSize, _unref(catalogServices).totalItems),
          "total-items": _unref(catalogServices).totalItems,
          onPageChange: _cache[2] || (_cache[2] = (e) => requestParams.value.page = e.detail.page)
        }, null, 40, _hoisted_11))
      : _createCommentVNode("", true),
    _cache[11] || (_cache[11] = _createTextVNode()),
    _createVNode(CatalogServiceModal, {
      ref_key: "catalogServiceModal",
      ref: catalogServiceModal
    }, null, 512),
    _cache[12] || (_cache[12] = _createTextVNode()),
    _createVNode(CatalogServiceDeleteModal, {
      ref_key: "deleteModal",
      ref: deleteModal
    }, null, 512)
  ], 64))
}
}

})